import { Reducer } from "redux";
import { KeywordActionTypes } from "../types";
import { IWorkflowItemStep, IReport } from "../../../../common/sharedTypes";
import { CountyInfo, ReportTypesInfo } from "../../../Forms/Keywords/business-objects/common";
import { KeywordQueueItem, initialInvolvedParty } from "../business-objects/common";
export interface IKeywordQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
  keywords: any;
  counties: CountyInfo[];
  reportTypes: ReportTypesInfo[];
  currentImageWindow: any;
  reportMatches: IReport[];
  image: Uint8Array;
  keywordQueueItems: KeywordQueueItem[];
  totalKeywordQueueItems: number;
  loadingQueueItems: boolean;
}

const initialState: IKeywordQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  keywords: "",
  counties: [],
  reportTypes: [],
  currentImageWindow: null,
  reportMatches: [],
  image: null,
  keywordQueueItems: [],
  totalKeywordQueueItems: 0,
  loadingQueueItems: false,
};
var toUint8Array = require("base64-to-uint8array");

const getBase64Payload = (value: any): string => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    const dataUrlMatch = value.match(/^data:[^;]+;base64,(.*)$/);
    const base64 = dataUrlMatch ? dataUrlMatch[1] : value;
    const normalized = base64.replace(/\s/g, "").replace(/-/g, "+").replace(/_/g, "/");
    return normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
  }

  return getBase64Payload(value.pdf || value.data || value.image);
};

const toPdfBytes = (value: any): Uint8Array => {
  if (!value) {
    return null;
  }

  if (value instanceof Uint8Array) {
    return value;
  }

  if (value instanceof ArrayBuffer) {
    return new Uint8Array(value);
  }

  const base64 = getBase64Payload(value);
  if (!base64) {
    return null;
  }

  try {
    return toUint8Array(base64);
  } catch (ex) {
    console.error("Invalid PDF base64 payload", ex);
    return null;
  }
};

const reducer: Reducer<IKeywordQueueState> = (state = initialState, action) => {
  switch (action.type) {
    case KeywordActionTypes.LOAD_REPORT_MATCHES: {
      let _state = { ...state };
      _state = { ...state, reportMatches: action.value };
      return _state;
    }
    case KeywordActionTypes.SEARCH_KEYWORDS_ITEMS:
      return { ...state, keywordQueueItems: action.value };
    case KeywordActionTypes.SEARCH_KEYWORDS_TOTAL:
      return { ...state, totalKeywordQueueItems: action.value };
    case KeywordActionTypes.LOADING_KEYWORD_ITEMS:
      return { ...state, loadingQueueItems: action.value };
    case KeywordActionTypes.SEARCH_KEYWORDS: {
      let _state = { ...state };

      let wis: IWorkflowItemStep[] = action.value;
      wis = wis.map((w) => {
        if (w.workflowItem.report.keywords.involvedParties.length > 0) {
          w.workflowItem.report.keywords.involvedParties =
            w.workflowItem.report.keywords.involvedParties.map((ip) => {
              return {
                ...ip,
                businessOwned: ip.businessName && ip.businessName.length > 0 ? true : false,
              };
            });
        } else {
          w.workflowItem.report.keywords.involvedParties.push(initialInvolvedParty);
        }
        return w;
      });
      _state = { ...state, workflowItemSteps: wis };
      return _state;
    }
    case KeywordActionTypes.LOAD_IMAGE: {
      let _state = { ...state };

      const fileUrl = action.value.fileUrl;
      const forceNewWindow = action.value.forceNewWindow;
      if (!_state.currentImageWindow || forceNewWindow) {
        _state.currentImageWindow = window.open(fileUrl, "_blank", "width=1000,height=800");
        _state.currentImageWindow.onbeforeunload = function () {
          console.log("unloading window");
          _state.currentImageWindow = null;
        };
      } else {
        console.log(_state.currentImageWindow);
        _state.currentImageWindow.location.href = fileUrl;
      }
      return _state;
    }
    case KeywordActionTypes.UPDATE_WORKFLOW_ITEM_STEP: {
      let _state = { ...state };
      _state = {
        ...state,
        workflowItemSteps: _state.workflowItemSteps.map((wis) => {
          var newis = wis.id == action.value.id ? action.value : wis;
          return newis;
        }),
        openWorkflowItemStep: action.value,
        keywordQueueItems: _state.keywordQueueItems.map((wis) => {
          var newis = wis.id == action.value.id ? new KeywordQueueItem(action.value) : wis;
          return newis;
        }),
      };
      return _state;
    }
    case KeywordActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case KeywordActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case KeywordActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      _state.keywordQueueItems = [
        ..._state.keywordQueueItems.map((item) =>
          item.id == action.value.id ? new KeywordQueueItem(action.value) : item
        ),
      ];

      return _state;
    }
    case KeywordActionTypes.STATUS_CHANGE: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      _state.keywordQueueItems = [
        ..._state.keywordQueueItems.map((item) =>
          item.id == action.value.id ? new KeywordQueueItem(action.value) : item
        ),
      ];
      return _state;
    }
    case KeywordActionTypes.COMPLETE_DATA_ENTRY: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case KeywordActionTypes.LOAD_COUNTIES_INTO_STORE: {
      let _state = {
        ...state,
        counties: action.value,
      };
      return _state;
    }
    case KeywordActionTypes.LOAD_REPORT_TYPES_INTO_STORE: {
      let _state = {
        ...state,
        reportTypes: action.value,
      };
      return _state;
    }
    case KeywordActionTypes.GET_IMAGE: {
      let _state = { ...state };
      _state = { ...state, image: toPdfBytes(action.value) };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
